import PropTypes from "prop-types";
import Header from "./Header";
import SideNav from "./SideNav";
import { Outlet } from "react-router-dom";

export default function DashboardLayout({ children }) {
  return (
    <>
      <Header />
      <SideNav/>
      <Outlet />
    </>
  );
}

DashboardLayout.propTypes = { children: PropTypes.node };
